import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, X } from 'lucide-react';
export function ProblemSection() {
  const painPoints = ['Buscás información en Google y cada página dice algo diferente — terminás más confundido/a que antes.', 'Sentís miedo cada vez que comés porque no sabés si eso te va a disparar la glucosa.', "Te dieron una lista de 'prohibidos' pero nadie te dijo qué SÍ podés comer (y que sea rico).", 'Intentaste seguir dietas que parecen diseñadas para otra persona, no para tu vida real.', 'Te cansaste de depender solo de la medicación sin entender qué más podés hacer.', "En reuniones familiares o salidas, te sentís como un problema — siempre 'el/la de la dieta especial'."];
  return <section className="py-20 px-4 bg-white" data-id="element-222">
      <div className="max-w-4xl mx-auto" data-id="element-223">
        <div className="text-center mb-12" data-id="element-224">
          <span className="text-[#D97706] font-semibold tracking-wide uppercase text-sm" data-id="element-225">
            ¿Te suena familiar?
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B4332] mt-3 mb-6" data-id="element-226">
            Vivir con Diabetes No Debería Sentirse Como Caminar en un Campo
            Minado
          </h2>
          <p className="text-lg text-[#1C1917]/80 max-w-2xl mx-auto" data-id="element-227">
            Si tenés diabetes tipo 2 (o cuidás a alguien que la tiene),
            probablemente vivís con alguna de estas frustraciones:
          </p>
        </div>

        <div className="grid gap-4 md:gap-6" data-id="element-228">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 p-4 md:p-6 bg-red-50/50 rounded-xl border border-red-100" data-id="element-229">
              <div className="flex-shrink-0 mt-1" data-id="element-230">
                <X className="w-6 h-6 text-red-500" data-id="element-231" />
              </div>
              <p className="text-[#1C1917] font-medium text-lg" data-id="element-232">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="mt-12 text-center p-8 bg-[#FEFBF4] rounded-2xl border border-[#1B4332]/10" data-id="element-233">
          <p className="text-xl md:text-2xl font-bold text-[#1B4332]" data-id="element-234">
            No es tu culpa. El problema no es falta de voluntad — es falta de un
            sistema claro y práctico que funcione en tu vida real.
          </p>
        </motion.div>
      </div>
    </section>;
}